// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__13Oy2","noContent":"styles_noContent__2lVC_"};